<template>
  <div class="modal fade" tabindex="-1" id="modal_patient" data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl">
      <form method="post" @submit.prevent="submitFormEdit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Paciente </h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                 @click="$emit('onCloseModal')"
                 data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <!-- Tabs Navigation -->
            <ul class="nav nav-tabs nav-line-tabs mb-4" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" data-bs-toggle="tab" href="#tab-dados" role="tab" aria-selected="true">
                  Dados
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-bs-toggle="tab" href="#tab-convenios" role="tab" aria-selected="false">
                  Convênios
                </a>
              </li>
            </ul>

            <!-- Tabs Content -->
            <div class="tab-content">
              <!-- Tab Dados -->
              <div class="tab-pane fade show active" id="tab-dados" role="tabpanel">
                <div class="row">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2 required">Nome</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. João dos Santos" v-model="form.patient_name"/>
              </div>
              <div class="col-md-6">
                <PatientIdentityFields :form="form" cpf-field="patient_cpf" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2 required">Celular</label>
                <input type="text" class="form-control form-control-solid"
                       v-mask="['(##) ####-####', '(##) #####-####']" required
                       placeholder="Ex. 1998551-4614" v-model="form.patient_phone"/>
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2 required">Data Nascimento</label>
                <input type="text" class="form-control form-control-solid"
                       v-mask="'##/##/####'" required
                       placeholder="Ex. 08/12/1990" v-model="form.patient_birthdate"/>
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2">Sexo</label>
                <select class="form-select form-select-solid" v-model="form.patient_gender">
                  <option :value="null">Selecione</option>
                  <option value="Male">Masculino</option>
                  <option value="Female">Feminino</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">E-mail</label>
                <input type="email" class="form-control form-control-solid"
                       placeholder="Ex. joao@gmail.com" v-model="form.patient_email"/>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">RG</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. 54497955-6" v-model="form.patient_rg"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">CNS</label>
                <input type="text" class="form-control form-control-solid"
                       v-mask="'### #### #### ####'"
                       placeholder="Ex. 123 4567 8901 2345" v-model="form.patient_cns"/>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Nome da Mãe</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. Maria Silva dos Santos" v-model="form.patient_mother_name"/>
              </div>
            </div>
            <div class="border-top my-4"></div>
            <div class="row">
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">CEP</label>
                <input type="text" class="form-control form-control-solid"
                       v-mask="'#####-###'"
                       placeholder="Ex. 13000-000" v-model="form.patient_zipcode"
                       @blur="getZipCode"/>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Rua</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. Rua das Flores" v-model="form.patient_street"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="fs-6 fw-bold mb-2">Número</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. 123" v-model="form.patient_number"/>
              </div>
              <div class="col-md-4">
                <label class="fs-6 fw-bold mb-2">Bairro</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. Centro" v-model="form.patient_neighborhood"/>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Complemento</label>
                <input type="text" class="form-control form-control-solid"
                       placeholder="Ex. Apt 101" v-model="form.patient_complement"/>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Estado</label>
                <select class="form-control form-control-solid"
                        @change="getCitiesFromState($event.target.value)"
                        v-model="form.id_state">
                  <option :value="state.id_state" v-for="state in states">
                    {{ state.state_name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="fs-6 fw-bold mb-2">Cidade</label>
                <select class="form-control form-control-solid"
                        v-model="form.id_city">
                  <option :value="city.id_city" v-for="city in citiesFromState">
                    {{ city.city_name }}
                  </option>
                </select>
              </div>
            </div>
              </div>

              <!-- Tab Convênios -->
              <div class="tab-pane fade" id="tab-convenios" role="tabpanel">
                <PatientInsurances v-if="patient" :patient="patient" :place="place" />
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">Atualizar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { patientIdentity } from '../../helpers/patientIdentity';
import http from "../../helpers/http";
import {mask} from "vue-the-mask";
import Alert from "../../helpers/alert";
import PatientInsurances from "./PatientInsurances.vue";

export default {
  name: "ModalPatient",
  components: {
    PatientInsurances
  },
  props: ['patient', 'openModal'],
  emits: ['onCloseModal', 'onPatientUpdated'],
  directives: {
    mask,
  },
  data() {
    return {
      states: [],
      citiesFromState: [],
      form: {
        patient_name: null,
        patient_cpf: null,
        patient_phone: null,
        patient_birthdate: null,
        patient_gender: null,
        observations: null,
        patient_email: null,
        patient_rg: null,
        patient_cns: null,
        patient_mother_name: null,
        patient_zipcode: null,
        patient_street: null,
        patient_number: null,
        patient_neighborhood: null,
        id_city: null,
        id_state: null,
        patient_complement: null,
      }
    }
  },
  created() {
    this.getStates();
  },
  async mounted() {
    if (this.patient != null) {
      await this.syncFormFromPatient(this.patient);
      if (this.openModal) {
        this.toggleModal();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  watch: {
    async openModal(newValue) {
      if (newValue && this.patient != null) {
        await this.syncFormFromPatient(this.patient);
        this.toggleModal();
      }
    },
    async patient(newValue) {
      if (newValue == null) {
        return;
      }
      await this.syncFormFromPatient(newValue);
    },
  },
  methods: {
    date: moment,
    async syncFormFromPatient(patient) {
      const savedCityId = patient.id_city;

      this.form = {
        patient_name: patient.patient_name,
        ...patientIdentity(patient),
        patient_cpf: patient.patient_cpf,
        patient_phone: patient.patient_phone,
        patient_birthdate: this.date(patient.patient_birthdate).format('DD/MM/YYYY'),
        patient_gender: patient.patient_gender ?? null,
        observations: patient.observations,
        patient_email: patient.patient_email,
        patient_rg: patient.patient_rg,
        patient_cns: patient.patient_cns,
        patient_mother_name: patient.patient_mother_name,
        patient_zipcode: patient.patient_zipcode,
        patient_street: patient.patient_street,
        patient_number: patient.patient_number,
        patient_neighborhood: patient.patient_neighborhood,
        id_city: savedCityId,
        id_state: patient.id_state,
        patient_complement: patient.patient_complement,
      };

      if (this.form.id_state) {
        await this.getCitiesFromState(this.form.id_state, false);
        this.form.id_city = savedCityId;
      }
    },
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId, clearCity = true) {
      if (clearCity) {
        this.form.id_city = null;
      }
      if (!stateId) {
        this.citiesFromState = [];
        return;
      }
      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;
        return response;
      });
    },
    getZipCode() {
      if (!this.form.patient_zipcode || this.form.patient_zipcode.length < 9) {
        return;
      }
      http.get(`zipcode/` + this.form.patient_zipcode.replace(/-/g, '')).then((response) => {
        this.form.patient_street = response.data.address;
        this.form.patient_neighborhood = response.data.neighborhood;
        this.form.id_state = response.data.state?.id_state;
        if (this.form.id_state) {
          this.getCitiesFromState(this.form.id_state).then(() => {
            this.form.id_city = response.data.city?.id_city;
          });
        }
      }).catch((e) => {
        console.log(e.response);
      });
    },
    submitFormEdit() {
      http.put(`/places/${this.place.id_place}/patients/${this.patient.id_patient}`, this.form).then(() => {
        Alert.toastSuccess('Paciente atualizado com sucesso.');

        this.$emit('onPatientUpdated');
        this.$emit('onCloseModal');
        this.toggleModal();
      }).catch((e) => {
        Alert.toastError(e.response.data.message ?? e.response.data);
      });
    },
    toggleModal() {
      let modal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modal_patient'));
      modal.toggle();
    },
  }
}
</script>

<style scoped>

</style>